import { render, staticRenderFns } from "./AttributeMapping.vue?vue&type=template&id=31148409&scoped=true"
import script from "./AttributeMapping.vue?vue&type=script&lang=js"
export * from "./AttributeMapping.vue?vue&type=script&lang=js"
import style0 from "./AttributeMapping.vue?vue&type=style&index=0&id=31148409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31148409",
  null
  
)

export default component.exports